import React from 'react';

import styled from 'styled-components';

import Picture from 'components/picture';
import { IImageFragment } from 'generated/sanity-graphql';

import theme from './theme';

const Container = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 14px 0 12px;
`;

const Icon = styled(Picture)`
  height: 28px;
  width: 28px;
  margin-bottom: 4px;
  margin-right: 8px;
`;

const Text = styled.p`
  margin: 0;
  font-family: ${Styles.fontFamily.body};
  color: ${theme.textColor};
  font-size: 0.85rem;
`;

interface IEndOfOffersProps {
  image: IImageFragment | null;
  message: string;
}

export const EndOfOffers: React.FC<IEndOfOffersProps> = ({ image, message }) => (
  <Container>
    {image && <Icon image={image} alt={message} objectFitContain />}
    <Text>{message}</Text>
  </Container>
);
